import React from 'react';
import styles from 'components/show_drawing/redraw_form/_style.module.scss';

const ComboErrorsBanner = ({ errors }) => {
  if (!errors || errors.length === 0) { return null; }

  return (
    <div className={styles.combo_errors_banner}>
      {errors.map((message, index) => (
        <div key={index}>{message}</div>
      ))}
    </div>
  );
};

export default ComboErrorsBanner;
